import { render, staticRenderFns } from "./BeneficiaryAutoTopups.vue?vue&type=template&id=799dca88&scoped=true"
import script from "./BeneficiaryAutoTopups.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAutoTopups.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryAutoTopups.vue?vue&type=style&index=0&id=799dca88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799dca88",
  null
  
)

export default component.exports